import React, { useEffect } from "react";
import { HelmetProvider } from 'react-helmet-async';
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";
import Home from "./pages/Home";

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <HelmetProvider>
      <div>
        <Home />
      </div>
    </HelmetProvider>
  );
}

export default App;
